import React from "react";
import * as UIConstants from "../UIConstants";

class CellStatus extends React.Component {
  shouldComponentUpdate(nextProps) {
    return (
      nextProps.requestStatus !== this.props.requestStatus ||
      nextProps.requestHasPdf !== this.props.requestHasPdf
    );
  }

  render() {
    var defaultCell =
      UIConstants.REQUEST_STATUS[UIConstants.REQUEST_STATUS.length - 1];
      //console.log("CellStatus");
      //console.log(this.props.requestStatus);
    if (
      this.props.requestStatus === null ||
      this.props.requestStatus === undefined
    ) {
      return;
    }
    for (var i = 0; i < UIConstants.REQUEST_STATUS.length; i++) {
      //console.log(UIConstants.REQUEST_STATUS[i].name);
        
      if (UIConstants.REQUEST_STATUS[i].name === this.props.requestStatus) {
        //console.log(UIConstants.REQUEST_STATUS[i].name);
        //console.log(this.props.requestStatus);
        //console.log(UIConstants.REQUEST_STATUS[i]);
        defaultCell = UIConstants.REQUEST_STATUS[i];
        break;
      }
    }

    return (
      <div align={this.props.align}>
        <span
          className={defaultCell.styleClass}
          style={{
            fontSize: this.props.fontSize ? this.props.fontSize : "0.8"
          }}
        >
          {defaultCell.label}
        </span>
        {this.props.requestHasPdf ? <i className="fa fa-paperclip" /> : null}
      </div>
    );
  }
}

export default CellStatus;



// WEBPACK FOOTER //
// ./src/components/UI/Widget/CellStatus.js